import PropTypes from 'prop-types';
import { uuidv4 } from 'shared/utils';
import { UploadedFilePreview } from 'shared/components/UploadedFilePreview';
import { FlexContainer, FileInput } from './FormSectionStyles';

const FILE_SIZE_LIMIT_BYTES = 5 * 1000 * 1000;

const IDFormSection = ({ values, errors, touched, setFieldValue, handleReset }) => {
  const tempFile = values.tempFile?.file;
  const tempFileName = tempFile?.name;
  const helperCopy =
    values.type === 'PASSPORT'
      ? 'First page of Passport'
      : 'Upload a photo of the front of your ID';
  return (
    <FlexContainer>
      <UploadedFilePreview file={tempFile} />

      <FileInput
        id="front-file"
        data-test-id="front-file"
        name="tempFile"
        label={tempFileName || helperCopy}
        errorText={touched.tempFile?.uuid && errors.tempFile?.uuid}
        onChange={async ({ target: { files } }) => {
          if (files?.[0]?.size > FILE_SIZE_LIMIT_BYTES) {
            setFieldValue('imageTooLarge', true);
          } else {
            const uuid = uuidv4();

            // Wait for first setFieldValue to finish before calling next
            // so that validation doesnt run with old data
            await setFieldValue('tempFile', {
              uuid,
              file: files[0],
              type: `${values.type}FRONT`,
            });
            setFieldValue('imageTooLarge', false);
          }
        }}
        file={{
          value: tempFile,
          complete: !!tempFile,
          progress: tempFile ? 100 : 0,
        }}
        onRemove={handleReset}
      />
    </FlexContainer>
  );
};

IDFormSection.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
};

export default IDFormSection;
